module.exports = __webpack_public_path__ + "img/icon11.6f0882e8.png";